/**
 * Discount Configuration — FALLBACK DEFAULTS ONLY.
 *
 * The Top Sellers / promo hero is now driven by the backend campaign config
 * (see services/promoConfig.js, fed by GET api/public/promo-section). These
 * constants are only used as the graceful fallback when that config can't be
 * loaded — promoConfig.getDefaultConfig() mirrors the values below.
 *
 * To change the live discount, edit the active campaign in the admin portal,
 * not this file.
 */

// Auto-discount: percent off when buying N+ games (fallback when no campaign loads)
export const AUTO_DISCOUNT_PERCENT = 30;
export const AUTO_DISCOUNT_MIN_GAMES = 3;

// Superseded by the campaign config (cfg.enabled / cfg.maxGames). Kept one release
// as fallbacks; safe to remove once the DB-driven path is proven.
export const TOP_SELLERS_ENABLED = true;
export const TOP_SELLERS_COUNT = 4;
